import admissionTestNames from '../../../assets/translations/admission-test-names.json'

export const admissionTestNamesContent: any = admissionTestNames
